import React from 'react';
import {Link, browserHistory} from 'react-router';
import './profile_navbar.less';
import MediaQuery from 'react-responsive';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import urlData from './url_config';

class ProfileNavBarMobile extends React.Component {
    constructor(props) {
        super(props);

        this.updateNavbarState = this.updateNavbarState.bind(this);
        this.updateTabHeader = this.updateTabHeader.bind(this);

    }

    updateNavbarState() {
        const {state} = this;
        var updatedNavBarState = !state.navbarOpen;

        this.setState({
            navbarOpen: updatedNavBarState
        });
    }

    updateTabHeader(currTab){
        this.setState({currNavTab: currTab}, () => {
            this.updateNavbarState();
        });
    }

    componentWillMount(){

        //  const {props} = this;
         let pathname = this.props.pathname.replace(/\//ig, '');
         let tabHeader;
         (pathname == 'profile') ? tabHeader = this.props.userData.name : tabHeader = this.mapRouteToHeaderName(pathname);
          this.state = {
            currNavTab: tabHeader,
            navbarOpen: true
        }
      this.updateTabHeader(tabHeader);
      // this.updateNavbarState();
    }

    mapRouteToHeaderName(pathname){
      const routeArr = urlData.routeArr;
      const tabArr = urlData.tabArr;

      let routeIndex = routeArr.indexOf(pathname);
      return tabArr[routeIndex]
    }

    render() {
        const {props, state} = this;
        let {userData} = props;
        var self = this;
        var name = userData.name;
        const tabArr = urlData.tabArr;

        return (
            <div className="mobile-account-navbar">
              <div className="wrapper">
                <div className="awb-selected-tab awb-btn" onClick={this.updateNavbarState}>
                  {state.currNavTab}<span className="icon-down-arrow-outline"></span>
                </div>
                {/*state.navbarOpen
                  ? <div className="nav-divider-line-elm" ref="navbarDividerLine"></div>
                : null*/}
                {state.navbarOpen
                  ? <div className="mobile-nav-tab-wrap navbar" ref="navbarBody">
                    <Link to="/profile" className="user-details-wrap" activeClassName="active-account-navbar-elm" onClick={this.updateTabHeader.bind(self, name)}>
                      <div className="user-profile-details-wrap">{name} {userData.isVerified && <div className="account-verified-elm"></div>}</div>
                    </Link>
                    {/*<div className="nav-divider-line-elm"></div>*/}
                    <div className="account-navbar-elm-wrap">
                      <Link to="/my-trips" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                        <div>My Trips</div>
                      </Link>
                    </div>
                    <div className="account-navbar-elm-wrap">
                      <Link to="/account" className="account-navbar-elm" activeClassName="active-account-navbar-elm" onClick={this.updateTabHeader.bind(self, tabArr[0])}>
                        <div>Account</div>
                      </Link>
                      <Link to="/account-payment" className="account-navbar-elm" activeClassName="active-account-navbar-elm" onClick={this.updateTabHeader.bind(self, tabArr[0])}>
                        <div>Payment</div>
                      </Link>
                      <Link to="/notifications" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                        <div>Notifications</div>
                      </Link>
                      <Link to = "/id-verification"className="account-navbar-elm cf cursor-default" activeClassName="active-account-navbar-elm">
                        <div className="f-l">
                          ID Verification
                        </div>
                        {userData.isVerified &&<div className="f-r align-middle navbar-details-val">
                           <div  className="account-verified-elm"></div><div className="account-verified-text-elm">Verified</div>
                        </div>}
                      </Link>
                    </div>
                    <div className="account-navbar-elm-wrap ">
                      <Link className="account-navbar-elm cursor-default cf" activeClassName="active-account-navbar-elm">
                        <div className="f-l">
                          Account Credit
                        </div>
                        <div className="f-r navbar-details-credit">
                          {userData.creditAmount ? userData.creditAmount : 0}$
                        </div>
                      </Link>
                      <Link to="/promocode" className="account-navbar-elm cursor-default" activeClassName="active-account-navbar-elm">
                        <div>Enter Promo Code</div>
                      </Link>
                      <Link to="/invite-friends"className="account-navbar-elm cursor-default" activeClassName="active-account-navbar-elm">
                        <div>Invite Friends - Get 20% Off</div>
                      </Link>
                    </div>
                    <div className="account-navbar-elm-wrap">
                      <Link to="/how-it-works" className="account-navbar-elm" activeClassName="active-account-navbar-elm" onClick={this.updateTabHeader.bind(self, tabArr[3])}>
                        <div>How AWB Works</div>
                      </Link>
                      <Link to="/contact-support"className="account-navbar-elm cursor-default" activeClassName="active-account-navbar-elm">
                        <div>Contact Support</div>
                      </Link>
                      <Link to="/send-feedback"className="account-navbar-elm cursor-default" activeClassName="active-account-navbar-elm">
                        <div>Send Feedback</div>
                      </Link>
                      {/*
                      <Link to="/legal-content" className="account-navbar-elm" activeClassName="active-account-navbar-elm" onClick={this.updateTabHeader.bind(self, tabArr[6])}>
                        <div>Legal</div>
                      </Link>*/}
                    </div>
                    <div className="account-navbar-elm-wrap">
                      <div className="account-navbar-elm legal-header">Legal</div>
                      <Link to="/cookie-policy" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                        <div>Cookie Policy</div>
                      </Link>
                      <Link to="/privacy-policy" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                        <div>Privacy Policy</div>
                      </Link>
                      <Link to="/terms-and-conditions" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                        <div>Terms and Conditions</div>
                      </Link>
                    </div>
                  </div> : null}
              </div>
            </div>
                )
            }
        }

ProfileNavBarMobile.propTypes = {
  pathname: React.PropTypes.string.isRequired,
  userData: React.PropTypes.object.isRequired
};

module.exports = ProfileNavBarMobile;



// WEBPACK FOOTER //
// app/profile/profile_navbar/profile_navbar_mobile.jsx